export default "__VITE_ASSET__006fe885__"